import React from 'react';
import SiteLinks from './SiteLinks.js';

/*
  layout="form": content aligned with the assessment form card
  layout="wide" (default): full width with a small side inset
*/
export default function NavBar({ layout = "wide" }) {
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        if (!open) return;
        function handleKeyDown(event) {
            if (event.key === "Escape") setOpen(false);
        }
        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [open]);

    return (
        <div className="NavBar">
            <div className={`NavBar--inner NavBar--inner-${layout}`}>
                <a className="NavBar--logo" href="https://kizabo.com/">
                    <img src="/images/kizabo-logo.png" alt="Kizabo home" className="NavBar--logo-image" />
                </a>
                <button
                    type="button"
                    className={`NavBar--hamburger ${open ? "active" : ""}`}
                    onClick={() => setOpen(!open)}
                    aria-label={open ? "Close menu" : "Open menu"}
                    aria-expanded={open}
                    aria-controls="NavBar-menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
                {open && <div className="NavBar--backdrop" onClick={() => setOpen(false)} aria-hidden="true"></div>}
                <SiteLinks
                    id="NavBar-menu"
                    className={`NavBar--links ${open ? "is-open" : ""}`}
                    onNavigate={() => setOpen(false)}
                    phoneMenu
                />
            </div>
        </div>
    );
}
